import { initializeApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getAuth } from 'firebase/auth'
const firebaseConfig = {
  apiKey: "AIzaSyAHwReyUwT0_mJ2b5WyxTy_iZvVvUQzHz0",
  authDomain: "elite-cravings-bakehouse.firebaseapp.com",
  projectId: "elite-cravings-bakehouse",
  storageBucket: "elite-cravings-bakehouse.firebasestorage.app",
  messagingSenderId: "273962229784",
  appId: "1:273962229784:web:d85fd658cb008b34d3a36d",
  measurementId: "G-PL8YNP4WBR"
};

const app = initializeApp(firebaseConfig)
export const db = getFirestore(app, 'ecb-crm')
export const auth = getAuth(app)